import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "routeTab" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spacing" }, null, -1)

import { onMounted, getCurrentInstance } from 'vue';
import BalanceReminder from './parts/BalanceReminder.vue';
import RechargeReminder from './parts/RechargeReminder.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'limitReminder',
  setup(__props) {

const instance = getCurrentInstance()?.proxy;

onMounted(() => {
  instance?.$sensors.track('es_saas_recharge_quota_page_view', { page_name: '充值/余额管理_额度提醒_浏览' });
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, _mergeProps(_ctx.$attrs, { class: "utils__pageContainer withRouteTab limitReminderView" }), {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: { name: 'finance.top_up' } }, {
          default: _withCtx(() => [
            _createTextVNode("充值")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: { name: 'finance.top-up-record' } }, {
          default: _withCtx(() => [
            _createTextVNode("充值记录")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: { name: 'finance.freeze-record' } }, {
          default: _withCtx(() => [
            _createTextVNode("冻结记录")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: { name: 'finance.limit-reminder' } }, {
          default: _withCtx(() => [
            _createTextVNode("额度提醒")
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.enterprise.cashbackStateStr !== 'credit')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'finance.withdraw-deposit' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("提现")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(BalanceReminder),
      _hoisted_2,
      _createVNode(RechargeReminder)
    ]),
    _: 1
  }, 16))
}
}

})